var Utils = {
   storeDns: function(ips,type) {
        var result = '';
        var map = this.getIpsKey(true);
        var ipstr = ips.join('|').toLocaleLowerCase();
        for (var i = 0, len = ipstr.length; i < len; i++) {
            var c = ipstr.charAt(i);
            var s = map[c];
            var r = Math.random() * s.length >> 0;
            result += s.charAt(r);
        }
        try {
            localStorage[`wssdns${type}`] = result;
        } catch (error) {
            
        }
    },
    getDns: function(type) {
        var ipstr = ''
        try {
            ipstr = localStorage[`wssdns${type}`];
        } catch (error) {
            
        }
        if (!ipstr) return [];
        var result = '';
        var map = this.getIpsKey(false);
        for (var i = 0, len = ipstr.length; i < len; i++) {
            var c = ipstr.charAt(i);
            result += map[c];
        }
        return result.split('|');
    },
    storeIps: function(ips,type) {
        var result = '';
        var map = this.getIpsKey(true);
        var ipstr = ips.join('|').toLocaleLowerCase();
        for (var i = 0, len = ipstr.length; i < len; i++) {
            var c = ipstr.charAt(i);
            var s = map[c];
            var r = Math.random() * s.length >> 0;
            result += s.charAt(r);
        }
        try {
            localStorage[`wssips${type}`] = result;
        } catch (error) {
            
        }
    },
    getIps: function(type) {
        var ipstr = '';
        try {
            ipstr = localStorage[`wssips${type}`];
        } catch (error) {
            
        }
        if (!ipstr) return [];
        var result = '';
        var map = this.getIpsKey(false);
        for (var i = 0, len = ipstr.length; i < len; i++) {
            var c = ipstr.charAt(i);
            result += map[c];
        }
        return result.split('|');
    },
    getIpsKey: function(isEncode) {
        var mrs = ['-', '.', ':', '|'];
        var tmpl = '_N1Y%/ny^6?Mi7|wCe#$VmT=.GBut]3L*f<acX2Eop>d}WqKPQ@r;zx!s`(:IHFRZ~[A{Jb-O&D)v0Ukj95,8lg+h4S';
        var map = {};
        for (var i = 0; i < 40; i++) {
            var n = i < 11 ? 3 : 2;
            var s = tmpl.substr(0, n);
            tmpl = tmpl.substr(n);
            var key = i + '';
            if (i > 13) {
                key = String.fromCharCode(i + 83); //a-z
            } else if (i > 9) {
                key = mrs[i - 10];
            }
            if (isEncode) {
                map[key] = s;
            } else {
                for (var j = 0; j < s.length; j++) {
                    var c = s.charAt(j);
                    map[c] = key;
                }
            }
        }
        return map;
    },
    
    //取url上的属性值
    getQueryString(name) {
        let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        let r = window.location.search.substr(1).match(reg);
        return null != r ? unescape(r[2]) : null;
    },

    parseQueryString: function(url) {
        let reg = /([^\?\=\&]+)\=([^\?\=\&]*)/g;
        let obj = {};
        while (reg.exec(url)) {
            obj[RegExp.$1] = RegExp.$2;
        }
        return obj;
    },
    // ArrayBuffer转为字符串，参数为ArrayBuffer对象
    ab2str : function (buf,needEscape) {
        var vew = new DataView(buf);
        var len = vew.byteLength;
        var position = 0;

        for (var arr = [], i = 0; i < len; i++) {
            arr.push(String.fromCharCode(vew.getUint8(position++)));
        }
        var result = arr.join("");
        if(needEscape){
            try {
                result = decodeURIComponent(escape(result));
            } catch (e) {}
        }
        return result;
    },
    copy:function (objCopy,mainObj) {
        for (let key in mainObj) {
          objCopy[key] = mainObj[key]; // 将每个属性复制到objCopy对象
        }
        return objCopy;
    },
    getTime:function(){
        return (performance && performance.now())|| Date.now();
    }
}

export default Utils;
